import React, { useEffect, useState } from "react";
import HlsVideoPlayer from "./HlsVideoPlayer";
import {connect} from 'react-redux';
import { checkCustomer } from '../../components/utlity/checkCustomer';
import {  useNavigate } from "react-router-dom";

const VideoCard = ({ video, userProfile }) => {
    const [ canAccess, setCanAccess ] = useState(false);
    const navigate = useNavigate();

    useEffect(() => { 
        if(checkCustomer(userProfile)){
            setCanAccess(true);
        }
    })

    const downloadVideo = (videoUrl) => {
        if(canAccess){
            window.location.href = videoUrl;
        } else {
            navigate('/subscription/plans')
        }
        
    }

    return (
        <div className="card">
        <h4>{video.title}</h4>

        <HlsVideoPlayer
            src={video.streamUrl}
            poster={video.poster}
            videoId={video.id}
        />

        {video.downloadUrl  && (
            <span
            onClick={() => downloadVideo(video.downloadUrl)}
            download
            rel="noopener noreferrer"
            className="download-btn cp"
            >
            ⬇ Download
            </span>
        )}
        </div>
    );
};

function mapStateToProps(state) {
    return {
        userProfile: state.customer.customerProfile
    };
}
   
function mapDispatchToProps(dispatch) {
    return {
        
    };
}
  
export default connect(mapStateToProps, mapDispatchToProps)(VideoCard);
